module.exports = __webpack_public_path__ + "static/media/Panorama-Give-me-back-my-mountains.08f0df41.jpg";